import events from './events.json';
import eventSteps from './event-steps.json';
import createEvent from './create-event.json';

export default {
  events,
  eventSteps,
  createEvent,
};
